import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import SidePanelDrawer from '../../../b3-custody/shared/SidePanelDrawer';
import { HistoryEvent } from '../../../../../services/eventingApi';
import { formatDateTime } from '../shared/format';
import { buttonClass } from '../shared/ui';
import DeliveryReceipts from './DeliveryReceipts';
import DrawerBlock, { FieldTable } from './DrawerBlock';

interface EventDrawerProps {
  event: HistoryEvent | null;
  onClose: () => void;
  onReplay: (event: HistoryEvent) => void;
}

const asObject = (payload: unknown): object => (typeof payload === 'object' && payload !== null ? payload : { raw: payload });

const EventDrawer = ({ event, onClose, onReplay }: EventDrawerProps) => {
  if (!event) return null;
  const { message, aggregate } = event;

  return (
    <SidePanelDrawer
      isOpen
      title={message.eventType}
      onClose={onClose}
      headerActions={
        <button type="button" className={buttonClass.secondary} onClick={() => onReplay(event)}>
          Reprocessar
        </button>
      }
    >
      <DrawerBlock title="message">
        <FieldTable
          fields={[
            ['eventId', message.eventId],
            ['eventType', message.eventType],
            ['occurredAt', message.occurredAt],
            ['correlationId', message.correlationId],
            ['causationId', message.causationId],
            ['delivery', message.deliveryFormatted],
            ['target', message.target],
            ['payloadRef', message.payloadRef],
            ['publicado em', formatDateTime(event.publishedAt)],
          ]}
        />
      </DrawerBlock>
      <DrawerBlock title="aggregate">
        <FieldTable
          fields={[
            ['aggregateId', aggregate.aggregateId],
            ['aggregateVersion', aggregate.aggregateVersion],
          ]}
        />
      </DrawerBlock>
      <DrawerBlock title="payload (corpo raw)">
        <div className="max-h-80 overflow-auto rounded-md border border-gray-200 text-xs dark:border-gray-700">
          <JsonView data={asObject(event.payload)} shouldExpandNode={allExpanded} style={defaultStyles} />
        </div>
      </DrawerBlock>
      <DrawerBlock title="Entregas (eventing.delivery)">
        <DeliveryReceipts eventId={message.eventId} />
      </DrawerBlock>
    </SidePanelDrawer>
  );
};

export default EventDrawer;
